/* FYE UI behaviours (2026-07): consolidated from inline scripts in
   snippets/fye-mobile-menu.liquid and sections/header-bottom.liquid.
   Loaded once with defer from layout/theme.liquid. */
(function(){
  var menu=document.getElementById("fye-mobmenu");
  if(!menu)return;
  var l2=document.getElementById("fye-l2"), l2Title=document.getElementById("fye-l2-title");
  var items=Array.prototype.slice.call(menu.querySelectorAll(".fye-navlist > li[data-section]"));
  function openMenu(){menu.classList.add("is-open");document.body.classList.add("fye-menu-locked");}
  function closeMenu(){menu.classList.remove("is-open");document.body.classList.remove("fye-menu-locked");closeLevel2();}
  function openLevel2(li){
    var id=li.getAttribute("data-section"), secs=menu.querySelectorAll(".fye-sec");
    for(var i=0;i<secs.length;i++)secs[i].classList.toggle("is-active",secs[i].id===id);
    items.forEach(function(it){it.querySelector(".fye-navrow").setAttribute("aria-expanded",String(it===li));});
    l2Title.textContent=li.getAttribute("data-title");l2.classList.add("is-open");l2.scrollTop=0;
  }
  function closeLevel2(){l2.classList.remove("is-open");items.forEach(function(it){it.querySelector(".fye-navrow").setAttribute("aria-expanded","false");});}
  function bindHamburger(){
    var hb=document.querySelector(".t4s-push-menu-btn");
    if(!hb||hb.dataset.fyeBound)return;
    var c=hb.cloneNode(true);c.dataset.fyeBound="1";
    hb.parentNode.replaceChild(c,hb);
    c.addEventListener("click",function(e){e.preventDefault();e.stopPropagation();openMenu();});
  }
  bindHamburger();
  document.getElementById("fye-menu-close").addEventListener("click",closeMenu);
  document.getElementById("fye-menu-back").addEventListener("click",closeLevel2);
  items.forEach(function(li){li.querySelector(".fye-navrow").addEventListener("click",function(){openLevel2(li);});});
  document.addEventListener("keydown",function(e){if(e.key!=="Escape")return;if(l2.classList.contains("is-open"))closeLevel2();else closeMenu();});
})();

(function(){
  // Contact Us bar toggle (mobile)
  var bar = document.querySelector('.mbbtn .fye-contactbar');
  if(bar){
    bar.addEventListener('click', function(){
      var wrap = bar.closest('.mbbtn');
      var open = wrap.classList.toggle('is-open');
      bar.setAttribute('aria-expanded', String(open));
    });
  }
  // Swap theme icons for the design set (keeps their click behaviour)
  function swap(sel, svg){ var el=document.querySelector(sel); if(!el) return; var s=el.querySelector('svg'); if(s) s.outerHTML=svg; }
  var menu   = '<svg class="fye-ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"><path d="M4 6h16"/><path d="M4 12h16"/><path d="M4 18h16"/></svg>';
  var search = '<svg class="fye-ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="7"/><path d="m21 21-4.3-4.3"/></svg>';
  var account= '<svg class="fye-ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"><path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>';
  var basket = '<svg class="fye-ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z"/><path d="M3 6h18"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>';
  var heart  = '<svg class="fye-ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"><path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.29 1.49 4.04 3 5.5l7 7Z"/></svg>';
  function run(){
    swap('.t4s-push-menu-btn', menu);
    swap('.t4s-site-nav__search', search);
    swap('.t4s-site-nav__account', account);
    swap('.t4s-site-nav__cart', basket);
    swap('.t4s-col-group_btns > .t4s-site-nav__icon', heart); // theme wishlist (desktop)
    // mobile heart between search and basket
    var cart = document.querySelector('.t4s-col-group_btns .t4s-site-nav__cart');
    if(cart && !document.querySelector('.fye-wishlist')){
      var a=document.createElement('a');
      a.className='t4s-site-nav__icon fye-wishlist';
      a.href='/search?view=wishlist';
      a.setAttribute('aria-label','Wishlist');
      a.innerHTML=heart;
      cart.parentNode.insertBefore(a, cart);
    }
  }
  if(document.readyState!=='loading') run(); else document.addEventListener('DOMContentLoaded', run);
})();

/* FYE centre-diamond fee reconciler (Phase 1, 2026-07-31).
   Cart page only: keeps the hidden setting-fee line (variant 58461224927616,
   the £80 "customer's own diamond" fee) in step with the number of
   "Customer's own diamond" ring lines. Removing the ring removes the fee on
   the next cart-page load; removing just the fee brings it back. Gated to
   /cart so no extra requests happen on other pages. */
(function(){
  if (location.pathname.indexOf("/cart") !== 0) return;
  var FEE_VARIANT = "58461224927616";
  fetch("/cart.js", { headers: { "Accept": "application/json" } })
    .then(function(r){ return r.json(); })
    .then(function(cart){
      var ringQty = 0, feeLine = null;
      (cart.items || []).forEach(function(it){
        var p = it.properties || {};
        if (p["Centre Diamond"] === "Customer's own diamond" ||
            p["Centre diamond"] === "Supplied by you (setting fee applies)") ringQty += it.quantity;
        if (String(it.variant_id) === FEE_VARIANT) feeLine = it;
      });
      if (feeLine && feeLine.quantity !== ringQty) {
        fetch("/cart/change.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", "Accept": "application/json" },
          body: JSON.stringify({ id: feeLine.key, quantity: ringQty })
        }).then(function(){ location.reload(); });
      }
    })
    .catch(function(){});
})();

/* FYE cart pairing (W711, 2026-08-13).
   Groups a setting + centre diamond/stone-fee line under "Your complete
   engagement ring" in both cart surfaces (mini-cart drawer and /cart page —
   both use [data-cart-items] > [data-cart-item], per snippets/cart-item.liquid
   and snippets/cart-item-page.liquid). Pairing key: the diamond/fee line
   carries a "Ring SKU" property (set in assets/product-block.js and
   snippets/centre-diamond-chooser.liquid) whose value equals the setting
   line's variant SKU — that's the only link that already exists between the
   two lines, so it's reused here rather than inventing a new property.
   Runs on load, on this theme's own add-to-cart events, and after any
   /cart/change|update|add|clear.js request resolves (a light fetch patch,
   scoped to cart endpoints) so it re-applies once the theme's native AJAX
   cart updates (remove / qty change) have re-rendered the item list. */
(function(){
  var RING_SKU_PROP = "Ring SKU";
  var running = false, pending = false, suppress = 0;

  function fmtMoney(cents){
    return "£" + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  function findItemEl(container, key){
    var link = container.querySelector('[data-cart-remove][data-id="' + key + '"]');
    return link ? link.closest("[data-cart-item]") : null;
  }

  function buildPairs(cartItems){
    var bySku = {};
    cartItems.forEach(function(it){
      if (it.sku) { (bySku[it.sku] = bySku[it.sku] || []).push(it); }
    });
    var pairs = [];
    cartItems.forEach(function(it){
      var props = it.properties || {};
      var ringSku = props[RING_SKU_PROP];
      if (!ringSku) return;
      var candidates = bySku[ringSku] || [];
      var setting = null;
      for (var i = 0; i < candidates.length; i++) {
        var c = candidates[i];
        if (!(c.properties && c.properties[RING_SKU_PROP])) { setting = c; break; }
      }
      if (setting) pairs.push({ setting: setting, stone: it });
    });
    return pairs;
  }

  function lockQuantity(itemEl){
    var wrap = itemEl.querySelector("[data-quantity-wrapper]");
    if (!wrap || wrap.dataset.fyePairLocked) return;
    wrap.dataset.fyePairLocked = "1";
    wrap.classList.add("fye-qty-locked");
    var input = wrap.querySelector("[data-quantity-value]");
    var qtyLabel = document.createElement("span");
    qtyLabel.className = "fye-pair-qty-fixed";
    qtyLabel.textContent = "Qty " + (input ? input.value : "1");
    wrap.parentNode.insertBefore(qtyLabel, wrap);
  }

  function removePairByKeys(settingKey, stoneKey){
    return fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ id: settingKey, quantity: 0 })
    }).then(function(){
      return fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: JSON.stringify({ id: stoneKey, quantity: 0 })
      });
    }).then(function(){ location.reload(); });
  }

  function bindRemoveGuard(itemEl, pairLabel, settingKey, stoneKey){
    var link = itemEl.querySelector("[data-cart-remove]");
    if (!link || link.dataset.fyePairGuarded) return;
    link.dataset.fyePairGuarded = "1";
    link.addEventListener("click", function(ev){
      ev.preventDefault();
      ev.stopImmediatePropagation();
      var ok = window.confirm(
        "This item is one half of \"" + pairLabel + "\". Removing it will also remove the paired item, " +
        "so your order doesn't end up with a setting and no stone (or a stone and no setting). Remove both?"
      );
      if (ok) removePairByKeys(settingKey, stoneKey);
    }, true);
  }

  function groupPair(container, pair){
    var settingEl = findItemEl(container, pair.setting.key);
    var stoneEl = findItemEl(container, pair.stone.key);
    if (!settingEl || !stoneEl) return;

    var pairLabel = "Your complete engagement ring";
    var already = settingEl.parentElement && settingEl.parentElement.classList.contains("fye-pair-group");

    if (!already) {
      var group = document.createElement("div");
      group.className = "fye-pair-group";

      var head = document.createElement("div");
      head.className = "fye-pair-group__head";
      head.innerHTML = "<span class=\"fye-pair-group__title\">" + pairLabel + "</span>";
      group.appendChild(head);

      settingEl.parentNode.insertBefore(group, settingEl);
      group.appendChild(settingEl);
      group.appendChild(stoneEl);

      var totals = document.createElement("div");
      totals.className = "fye-pair-group__totals";
      group.appendChild(totals);
    }

    var groupEl = settingEl.closest(".fye-pair-group");
    var totalsEl = groupEl.querySelector(".fye-pair-group__totals");
    var combined = pair.setting.final_line_price + pair.stone.final_line_price;
    totalsEl.innerHTML =
      "<span>Setting: " + fmtMoney(pair.setting.final_line_price) + "</span>" +
      "<span>Centre diamond: " + fmtMoney(pair.stone.final_line_price) + "</span>" +
      "<strong>Combined total: " + fmtMoney(combined) + "</strong>";

    lockQuantity(settingEl);
    lockQuantity(stoneEl);
    bindRemoveGuard(settingEl, pairLabel, pair.setting.key, pair.stone.key);
    bindRemoveGuard(stoneEl, pairLabel, pair.setting.key, pair.stone.key);
  }

  function run(){
    if (running) { pending = true; return; }
    var containers = document.querySelectorAll("[data-cart-items]");
    if (!containers.length) return;
    running = true;
    fetch("/cart.js", { headers: { "Accept": "application/json" } })
      .then(function(r){ return r.json(); })
      .then(function(cart){
        var pairs = buildPairs(cart.items || []);
        if (pairs.length) {
          suppress++;
          containers.forEach(function(container){
            pairs.forEach(function(pair){ groupPair(container, pair); });
          });
          setTimeout(function(){ suppress = Math.max(0, suppress - 1); }, 0);
        }
      })
      .catch(function(){})
      .then(function(){
        running = false;
        if (pending) { pending = false; run(); }
      });
  }

  var debounceTimer = null;
  function scheduleRun(){
    if (suppress > 0) return;
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(run, 250);
  }

  if (document.readyState !== "loading") run(); else document.addEventListener("DOMContentLoaded", run);
  document.addEventListener("cart:refresh", scheduleRun);
  document.addEventListener("cart:build", scheduleRun);
  document.addEventListener("cdc:added", scheduleRun);

  // The theme's own cart drawer/page updates (quantity change, remove,
  // add-to-cart) all go through Shopify's cart AJAX endpoints. Rather than
  // observing the whole DOM for churn (expensive on every page, for no
  // benefit outside the cart), watch specifically for those endpoints and
  // re-run once the theme's own request has resolved and re-rendered items.
  if (window.fetch && !window.__fyeCartFetchPatched) {
    window.__fyeCartFetchPatched = true;
    var origFetch = window.fetch;
    window.fetch = function(input, init){
      var url = typeof input === "string" ? input : (input && input.url) || "";
      var isCartMutation = /\/cart\/(change|update|add|clear)\.js/.test(url);
      var p = origFetch.apply(this, arguments);
      if (isCartMutation) p.then(function(){ scheduleRun(); }).catch(function(){});
      return p;
    };
  }
})();
